import React from 'react';

import cn from 'classnames';
import { noop } from 'lodash';
import { bool, element, string, oneOf, func, shape } from 'prop-types';

import s from './ShadowButton.css';

const COLOR_CLASS = {
  green: s.green,
  blue: s.blue,
  gray: s.gray,
};

const VARIANT_CLASS = {
  outlined: s.outlined,
  filled: s.filled,
};

const ShadowButton = ({
  icon,
  label,
  color,
  onClick,
  classes,
  variant,
  disabled,
  iconDirection,
  compact,
}) => (
  <button
    type="button"
    disabled={disabled}
    className={cn(
      s.root,
      COLOR_CLASS[color],
      VARIANT_CLASS[variant],
      {
        [s.rightIcon]: iconDirection === 'right',
        [s.compact]: compact,
      },
      classes.root,
    )}
    onClick={onClick}
  >
    {icon ? (
      <div
        className={cn(
          s.icon,
          { [s.noLabel]: !label, [s.compactLabel]: compact },
          classes.icon,
        )}
      >
        {icon}
      </div>
    ) : null}
    {label ? <div className={cn(s.label, classes.label)}>{label}</div> : null}
  </button>
);

ShadowButton.propTypes = {
  icon: element,
  label: string,
  onClick: func,
  disabled: bool,
  variant: oneOf(['outlined', 'filled']),
  color: oneOf(['green', 'blue', 'gray']),
  classes: shape({
    root: string,
    icon: string,
    label: string,
  }),
  iconDirection: oneOf(['left', 'right']),
  compact: bool,
};

ShadowButton.defaultProps = {
  icon: null,
  label: '',
  color: 'blue',
  disabled: false,
  variant: 'outlined',
  iconDirection: 'left',
  onClick: noop,
  classes: {
    root: '',
    icon: '',
    label: '',
  },
  compact: false,
};

export default ShadowButton;
